import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'
import authOnEnter from 'enrollment-platform/authOnEnter'
import PlanManagementV2Gate from './components/PlanManagementV2Gate'
import { PLAN_MANAGEMENT_V2 } from './paths'
import PlanManagementV2 from './PlanManagementV2'
import ReviewPlanSnapshot from './pages/ReviewPlanSnapshot/ReviewPlanSnapshot'
import PlanOverridesIndexRedirect from './pages/PlanOverrides/pages/PlanOverridesIndexRedirect'
import ListPlanBenefitOverride from './pages/PlanOverrides/pages/PlanBenefitOverrides/pages/ListPlanBenefitOverride/ListPlanBenefitOverride'
import ListPlanLocationOverride from './pages/PlanOverrides/pages/PlanLocationOverrides/pages/ListPlanLocationOverride/ListPlanLocationOverride'
import ListPlanSmokerRateOverride from './pages/PlanOverrides/pages/PlanSmokerRateOverrides/pages/ListPlanSmokerRateOverride/ListPlanSmokerRateOverride'
import ListPlanServiceAreaOverride from './pages/PlanOverrides/pages/PlanServiceAreaOverrides/pages/ListPlanServiceAreaOverride/ListPlanServiceAreaOverride'
import ListPlanAndRateOverride from './pages/PlanOverrides/pages/PlanAndRateOverrides/pages/ListPlanAndRateOverride/ListPlanAndRateOverride'

const PlanManagementV2Routes = [
  {
    path: PLAN_MANAGEMENT_V2,
    component: PlanManagementV2Gate,
    onEnter(_nextState, replace, callback) {
      authOnEnter({
        allowedRoles: [ROLE_PLATFORM_HIXME_ADMIN],
        callback,
      })
    },
    indexRoute: {
      component: PlanManagementV2,
    },
    childRoutes: [
      { path: ':id/review', component: ReviewPlanSnapshot },
      {
        path: 'overrides',
        indexRoute: { component: PlanOverridesIndexRedirect },
        childRoutes: [
          {
            path: 'plan-benefits',
            indexRoute: {
              onEnter(_nextState, replace) {
                replace(
                  `/${PLAN_MANAGEMENT_V2}/overrides/plan-benefits/inactive`
                )
              },
            },
            childRoutes: [
              { path: ':subtab', component: ListPlanBenefitOverride },
            ],
          },
          {
            path: 'locations',
            indexRoute: {
              onEnter(_nextState, replace) {
                replace(`/${PLAN_MANAGEMENT_V2}/overrides/locations/inactive`)
              },
            },
            childRoutes: [
              { path: ':subtab', component: ListPlanLocationOverride },
            ],
          },
          {
            path: 'smoker-rates',
            indexRoute: {
              onEnter(_nextState, replace) {
                replace(
                  `/${PLAN_MANAGEMENT_V2}/overrides/smoker-rates/inactive`
                )
              },
            },
            childRoutes: [
              { path: ':subtab', component: ListPlanSmokerRateOverride },
            ],
          },
          {
            path: 'service-areas',
            indexRoute: {
              onEnter(_nextState, replace) {
                replace(`/${PLAN_MANAGEMENT_V2}/overrides/service-areas/draft`)
              },
            },
            childRoutes: [
              { path: ':subtab', component: ListPlanServiceAreaOverride },
            ],
          },
          {
            path: 'plans-rates',
            indexRoute: {
              onEnter(_nextState, replace) {
                replace(`/${PLAN_MANAGEMENT_V2}/overrides/plans-rates/inactive`)
              },
            },
            childRoutes: [
              { path: ':subtab', component: ListPlanAndRateOverride },
            ],
          },
        ],
      },
    ],
  },
]

export default PlanManagementV2Routes
